var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxRectLogout = function Svg18PxRectLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.25 5.75v-1.5a2 2 0 0 1 2-2h5.5a2 2 0 0 1 2 2v9.5a2 2 0 0 1-2 2h-5.5a2 2 0 0 1-2-2v-1.5M3.5 11.75.75 9 3.5 6.25M.75 9h8.5"
  })));
};
export default Svg18PxRectLogout;